<template>
  <div>
    <modal class="news-deleted-modal" width="45%" height="auto" name="news-deleted-modal">
      <div class="modal_content">
        <h2>News supprimée.</h2>
      </div>
    </modal>
    <div class="list_news" v-for="(news, index) in all_news" :key="news['.key']">
      <NewsContent class="news_content" :editable="editable" @deleteNews="deleteNews" :news="news"></NewsContent>
    </div>
  </div>
</template>

<script>
import { newsCollection } from '../../firebase';

import NewsEditor from './NewsEditor';
import NewsContent from './NewsContent';

export default {
  name: 'NewsList',
  props: { editable: Boolean },

  data() {
    return {
      all_news: [],
    };
  },
  components: { NewsEditor, NewsContent },
  firestore: {
    all_news: newsCollection.orderBy('createdAt', 'desc'),
  },
  methods: {
    deleteNews(news) {
      this.$modal.show('news-deleted-modal');

      newsCollection.doc(news.id).delete();

      setTimeout(() => {
        this.$modal.hide('news-deleted-modal');
      }, 2000);
    },
  },
};
</script>

<style style="scss" scoped>
.news-deleted-modal {
  .modal_content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  h2 {
    font-size: 32px;

    margin-left: auto;
    margin-right: auto;
    padding: 16px;
    text-align: center;
  }
}

.news_content {
  margin-top: 32px;
}
</style>
